
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"1.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.162 22.192h11.999","fill":"none","stroke":"#000","stroke-width":"1.46","transform":"matrix(-1.27086 0 0 -1.45378 26.185 33.435)"}}),_c('path',{attrs:{"d":"M6 22.748l1.277-14.93","fill":"none","stroke":"#000","stroke-width":"1.47","transform":"matrix(-1.27086 0 0 -1.45029 27.25 34.165)"}}),_c('path',{attrs:{"d":"M18 22.748L16.419 7.854M7.277 7.854h9.142","fill":"none","stroke":"#000","stroke-width":"1.46","transform":"matrix(-1.27086 0 0 -1.45378 27.25 34.245)"}}),_c('path',{attrs:{"d":"M5.38 12l13.433-1.558","fill":"none","stroke":"#000","stroke-width":"2.02","transform":"matrix(.94503 0 0 1.03653 .783 .369)"}})])
          )
        }
      }
    